const brandLogos = ['brand-1.png', 'brand-2.png', 'brand-3.png', 'brand-4.png', 'brand-5.png', 'brand-8.png', 'brand-7.png'];

const Demo6Brands2 = () => {
    return (
        <div id="brands-2" className="wide-70 brands-section division">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="brands-title text-center">
                            <p className="p-xl">This guys are using OLMO and they are more than happier ever</p>
                        </div>
                    </div>
                </div>
                <div className="brands-2-wrapper">
                    <div className="row justify-content-md-center row-cols-2 row-cols-sm-3 row-cols-md-5">
                        {brandLogos.map((logo) => (
                            <div className="col" key={logo}>
                                <div className="brand-logo">
                                    <a href="#"> 
                                        <img className="img-fluid" src={`/images/demo6/${logo}`} alt="brand-logo" />
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demo6Brands2;
